import { ProcessStatus } from '../enums';

export interface WkProcessIdDetails {
  processInstanceId?: string;
  processDefinitionId?: string;
}

export interface WkProcessDiagramData extends WkProcessIdDetails {
  filter: ProcessStatus;
}
